export enum PaymentError {
  saving_card = 'We had a problem saving that card. Please check your card details or try a different card',
  card_decline = 'Your card was declined. Please check your card details or use a different card.',
  invalid_card_data = 'Invalid card data.'
}
